/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import MarkerRedIcon from '../../../assets/mapMarkers/MarkerRed.png';
import MarkerGreenIcon from '../../../assets/mapMarkers/MarkerGreen.png';

const eventMapping = {
  onClick: 'click',
  onDoubleClick: 'dblclick',
};

export default function useGoogleMapMarker({
  position,
  type,
  maps,
  map,
  events,
  title,
  active = false, //further improvements needed
  label,
}) {
  const [marker, setMarker] = useState();
  useEffect(() => {
    // const styles = markerStyle(type);
    const marker = new maps.Marker({
      position,
      map,
      title,
      icon: {
        url: active ? MarkerGreenIcon : MarkerRedIcon, //further improvements needed
        labelOrigin: { x: 12, y: -10 },
      },
      label: {
        text: label ? label : '',
        color: '#133a5c',
        fontWeight: '600',
        fontSize: '16px',
      },
    });
    Object.keys(events).forEach((eventName) =>
      marker.addListener(eventMapping[eventName], events[eventName]),
    );
    setMarker(marker);
  }, []);

  return marker;
}
